import { all, call, put, takeLatest } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { actions as offsetActions } from '@wix/da-shared-react/pkg/Stream/withOffset';
import { fetchTransactions } from '../../actions/studio/earnings';

function* handleFetchTransactions({
  payload: { streamId, limit, offset },
}: ReturnType<typeof fetchTransactions>) {
  const response = yield call(
    requestPuppy,
    {
      method: 'get',
      url: '/earnings/init',
      params: {
        init: false,
        limit,
        offset,
      },
    },
    undefined,
    'studio'
  );

  if (response?.transactions) {
    const { transactions, nextOffset, hasMore } = response;

    yield put(
      offsetActions.fetchSuccess({
        streamId,
        items: transactions,
        hasMore,
        hasLess: true,
        nextOffset,
        reset: true,
      })
    );
  }
}

export default function* saga() {
  yield all([takeLatest(fetchTransactions, handleFetchTransactions)]);
}
